import { render, staticRenderFns } from "./algoIcon.vue?vue&type=template&id=4c38d35c&"
import script from "./algoIcon.vue?vue&type=script&lang=js&"
export * from "./algoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports